import { EVENTS_SERVICE_URL, SERVICE_URL } from "../environment";
import { AnswersFactory } from "./AnswersFactory";
import { AnswersService } from "./AnswersService";
import { ApiService } from "./ApiService";
import { EventsChannelFactory } from "./EventsChannelFactory";
import { EventsService } from "./EventsService";
import { FormInstancesFactory } from "./FormInstancesFactory";
import { FormInstancesService } from "./FormInstancesService";
import { FormMembersFactory } from "./FormMembersFactory";
import { FormsService } from "./FormsService";
import { FormValidatorFactory } from "./FormValidatorFactory";
import { LoginService } from "./LoginService";
import { NotificationsService } from "./NotificationsService";
import { QueryParamsFactory } from "./QueryParamsFactory";
import { SessionService } from "./SessionService";
import { UsersService } from "./UsersService";
const eventsService = new EventsService(EVENTS_SERVICE_URL);
const eventsChannelFactory = new EventsChannelFactory(eventsService);
const queryParamsFactory = new QueryParamsFactory();
const sessionService = new SessionService();
const apiService = new ApiService(SERVICE_URL, sessionService);
const usersService = new UsersService(apiService);
const loginService = new LoginService(usersService, sessionService);
const formMembersFactory = new FormMembersFactory(eventsChannelFactory);
const formInstancesFactory = new FormInstancesFactory(eventsChannelFactory, formMembersFactory);
const instancesService = new FormInstancesService(apiService, queryParamsFactory, formInstancesFactory, formMembersFactory);
const answersService = new AnswersService(apiService, queryParamsFactory);
const formsService = new FormsService(apiService, queryParamsFactory, answersService);
const notificationsService = new NotificationsService();
const answersFactory = new AnswersFactory();
const formValidatorFactory = new FormValidatorFactory(answersService);
sessionService.isLoggedIn.subscribe(isLoggedIn => {
    if (isLoggedIn) {
        eventsService.start(sessionService.accessToken);
    }
    else {
        eventsService.end();
    }
});
export { loginService, formsService, formInstancesFactory, formMembersFactory, usersService, instancesService, notificationsService, answersService, answersFactory, eventsChannelFactory, sessionService, formValidatorFactory, };
export * from './functions';
